export const extractFacebookPixel = () => {
  return /_fbp=(fb\.\d+\.\d+\.\d+);?/.exec(document.cookie)?.[1];
};

export const extractFacebookClick = () => {
  return /_fbc=(fb\.\d+\.\d+\.[^;]*);?/.exec(document.cookie)?.[1];
};
